<template>
  <div class="aboutNX">
    <div class="banner" :style="`background-image:url(${banner.picUrl})`" :class="{canClick: banner.connection}">
      <h1 class="font-title">智能猪场服务专家</h1>
    </div>
    <div class="middle-content">
      <section>
        <h1>星级服务专家认证简介</h1>
        <p class="pb20">智能猪场（猪小智）星级专家认证是围绕农芯数科核心产品-猪小智展开，通过培训为市场服务人员建设完善知识体系，提升营销和服务能力，星级权利及责任调动市场服 务人员的工作积极性，有效提高个人销售业绩及主动服务意识，建立一支高素质、专业化的一线推广服务团队。</p>
        <div class="special">
          <div class="mol">
            <div class="icon">
              <div class="icon-img img-1"></div>
            </div>
            <div class="mol-con">
              <p class="title">目标</p>
              <div class="line blue-line"></div>
              <p class="detail">以客户为中心，达到客户满意。</p>
            </div>
          </div>
          <div class="mol">
            <div class="icon">
              <div class="icon-img img-2"></div>
            </div>
            <div class="mol-con">
              <p class="title">理念</p>
              <div class="line org-line"></div>
              <p class="detail">尽心尽责，尽善尽美。</p>
            </div>
          </div>
          <div class="mol">
            <div class="icon">
              <div class="icon-img img-3"></div>
            </div>
            <div class="mol-con">
              <p class="title">服务专家星级</p>
              <div class="line yel-line"></div>
              <p class="detail">三星级、四星级、五星级。</p>
            </div>
          </div>
        </div>
        <p class="rules-font">评选规则：通过制度化、规范化和标准化的星级认证服务专家培训，从企业文化与价值观、产品知识、业务技能及场景推演4方面进行考核，评选出高品质服务、高素质的智能猪场专业人员，对应 授予三星级、四星级、五星级专家称号，享受对应的权利及责任。</p>
      </section>

      <section class="m-b0">
        <h1 class="card-title">六大权利</h1>
        <ul class="power">
          <li class="rights-1 m-b30"><span class="power-font">专家奖金</span></li>
          <li class="rights-2 m-b30"><span class="power-font">项目绩效</span></li>
          <li class="rights-3 m-b30"><span class="power-font">优惠特权</span></li>
        </ul>
        <ul class="power">
          <li class="rights-4"><span class="power-font">VIP服务</span></li>
          <li class="rights-5"><span class="power-font">年会嘉宾</span></li>
          <li class="rights-6"><span class="power-font">成长机会</span></li>
        </ul>
      </section>

      <section class="m-b0">
        <h1 class="card-title">六大责任</h1>
        <ul class="power">
          <li class="duty-1"><span class="power-font">学习目标</span></li>
          <li class="duty-2"><span class="power-font">工作标准</span></li>
          <li class="duty-3"><span class="power-font">年度目标</span></li>
        </ul>
        <ul class="power">
          <li class="duty-4"><span class="power-font">推广讲师</span></li>
          <li class="duty-5"><span class="power-font">人才导师</span></li>
          <li class="duty-6"><span class="power-font">服务支持</span></li>
        </ul>
      </section>

      <section v-if="staffList.length > 0">
        <h1 class="card-title">专家团队</h1>
        <div class="staff-list">
          <section class="staff-card" v-for="(item, index) in staffList" :key="index">
            <div class="content">
            <div class="card-top">
              <div class="card-left">
                <div class="photo" :style="`background-image:url(${item.pictureUrl})`"></div>
                <div v-if="Number(item.starClass) === 3" class="star star-3"></div>
                <div v-if="Number(item.starClass) === 4" class="star star-4"></div>
                <div v-if="Number(item.starClass) === 5" class="star star-5"></div>
              </div>
              <div class="card-right">
                <p class="staff-name">{{item.employeeName}}</p>
                <p class="staff-title">{{item.title}}</p>
                <div class="mt-26">
                  <div class="site-icon"></div>
                  <p class="staff-area">{{item.region}}</p>
                </div>
                <div>
                  <div class="phone-icon"></div>
                  <p class="staff-area">{{item.telephone}}</p>
                </div>
              </div>
            </div>
            <div class="card-bottom">
              <p class="staff-con">{{item.introduce}}</p>
            </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  name: 'piggerySpecialist',
  data () {
    return {
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      staffList: []
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').service_expert
    }
    this.getExpertPage()
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    /**
    * 获取 banner 图片
    */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = arr.service_expert
      setSession('bannerPic', arr)
    },
    /** 服务专家 */
    async getExpertPage () {
      const params = {
        currentPage: 1,
        pageSize: 100,
        sortRule: 0
      }
      const res = await this.API.recruit.getExpertPage(params)
      this.staffList = res.data || []
    }
  }
}
</script>
